import { Injectable, inject } from '@angular/core';
import { Router, NavigationEnd, ActivatedRoute } from '@angular/router';
import { filter } from 'rxjs/operators';
import { signal } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class BreadcrumbService {
  private router = inject(Router);
  private activatedRoute = inject(ActivatedRoute);

  breadcrumbs = signal<Array<{ label: string; url: string }>>([]);

  constructor() {
    this.router.events
      .pipe(filter(event => event instanceof NavigationEnd))
      .subscribe((event: any) => {
        console.log('--- NavigationEnd event fired ---');
        console.log('Navigated to:', event.urlAfterRedirects);
        const trail = this.createBreadcrumbs(this.activatedRoute.root);
        console.log('Final generated breadcrumbs trail:', trail);
        this.breadcrumbs.set(trail);
      });
  }

  private createBreadcrumbs(
    route: ActivatedRoute,
    url: string = '',
    breadcrumbs: Array<{ label: string; url: string }> = []
  ): Array<{ label: string; url: string }> {
    console.log('--- createBreadcrumbs called ---');
    console.log('Current URL segment:', url);
    const children: ActivatedRoute[] = route.children;

    if (children.length === 0) {
      console.log('No more children found, returning trail.');
      return breadcrumbs;
    }

    for (const child of children) {
      const routeURL: string = child.snapshot.url
        .map(segment => segment.path)
        .join('/');

      console.log('Checking child route segment:', routeURL);

      if (routeURL !== '') {
        url += `/${routeURL}`;
      }

      const label = child.snapshot.data['breadcrumb'];
      if (label) {
        console.log(`Found breadcrumb label: "${label}" for URL: ${url}`);
        breadcrumbs.push({ label, url });
      } else {
        console.log('No breadcrumb label for this segment');
      }

      console.log('Recursing into child route...');
      return this.createBreadcrumbs(child, url, breadcrumbs);
    }

    return breadcrumbs;
  }
}